<template>
  <header class="header" :style="{boxShadow: height > 10 ? '0px 8px 8px 0px rgba(31,41,64,0.1)' : ''}">
    <div v-if="EN" class="header_box">
      <img src='../../assets/logo.svg' @click="changeRouter('/home')" class="header_logo" />
      <div class="header_box_right">
        <span class="header_sign" @click="goLink(`https://platform.antdiy.vip/#/?source=${source}`)">Sign in</span>
        <img src="../../assets/more.svg" alt="" class="header_more" @click="isShowNav = true">
      </div>
    </div>
    <div v-else class="header_box_cn">
      <img src='../../assets/cloud_logo_white.svg' @click="changeRouter('/cn/home')" class="header_logo" />
      <div class="header_box_right">
        <span class="header_sign" @click="goLink(`https://platform.antdiy.vip/#/?source=${source}`)">登录</span>
        <img src="../../assets/more_white.svg" alt="" class="header_more" @click="isShowNav = true">
      </div>
    </div>
    <div :class="isShowNav ? 'header_nav header_nav_show' : 'header_nav header_nav_show1'">
      <div class="header_nav_bg" @click="isShowNav = false"></div>
      <div :class="EN ? 'header_nav_box': 'header_nav_box header_nav_box_cn'">
        <div class="header_nav_top">
          <div v-if="EN" class="header_nav_top_box">
            <img class="header_nav_close" src="../../assets/close.svg" alt="" @click="isShowNav = false" />
          </div>
          <div v-else class="header_nav_top_box">
            <img class="header_nav_logo" src='../../assets/cloud_logo_white.svg' @click="changeRouter('home')" />
            <img class="header_nav_close2" src="../../assets/close_white.svg" alt="" @click="isShowNav = false" />
          </div>
          <div class="header_page">
            <div class="header_page_language" @click="showTab('Language')">
              <div>
                <img v-if="EN" src="../../assets/Earth.svg" alt="logo" class="header_language_image1" >
                <img v-else src="../../assets/Earth_white.svg" alt="logo" class="header_language_image1" >
                <span>{{Languagemobile}}</span>
              </div>
              <div>
                <img v-if="EN" src="../../assets/downarrow.svg" class="header_language_image2">
                <img v-else src="../../assets/downarrow_cn.svg" class="header_language_image2">
              </div>
            </div>
            <div v-if='Language' class="header_subtext_box">
              <div class="header_subtext_1" @click="changeLanguage('EN')">English</div>
              <div class="header_subtext_2" @click="changeLanguage('CN')">简体中文</div>
            </div>
            <div v-if="EN">
              <span v-for="(item, index) in pageList" :key="item.name" :class="item.tab == true ? 'header_drop_down' : 'header_text'"  @click="item.tab == true ? '' : changeRouter(item.link)"  >
                {{item.tab == true ? '' : item.name}}
                <div :class="pageList.length - 1 === index ? 'drop_down_tab last_box': 'drop_down_tab'" v-if="item.tab==true"  @click="showTab(item.name)">
                  <div class="header_drop_down_top">
                    <div :class="
                      item.link === 'products' ? 'header_drop_down_text proTag': null"
                      @click="changeRouter(item.link) ">
                      {{item.link === "products" ? "Products": null}}
                    </div>
                    <div class="header_drop_down_img" >
                      <img :class="
                        item.link === 'products' ? 'header_drop_down_img_button proTag': null"
                        src="../../assets/pull_down.svg">
                    </div>
                  </div>
                  <div v-if="item.link === 'products' && showProductFlag" class="header_subtext_box">
                    <div class="header_subtext_1" @click="changeRouter('/antdiy')">ANTDIY</div>
                    <div class="header_subtext_2" @click="changeRouter('/antdiypro')">ANTDIY Pro</div>
                  </div>
                </div>
              </span>
            </div>
            <div v-else>
              <span v-for="(item, index) in pageList2" :key="item.name" :class="item.tab == true ? 'header_drop_down' : 'header_text'"  @click="item.tab == true ? '' : changeRouter(item.link)"  >
                {{item.tab == true ? '' : item.name}}
                <div :class="pageList.length - 1 === index ? 'drop_down_tab last_box': 'drop_down_tab'" v-if="item.tab==true"  @click="showTab(item.name)">
                  <div class="header_drop_down_top">
                    <div :class="
                      item.link === '/cn/solution/raas' ? 'header_drop_down_text': null" @click="changeRouter(item.link)">
                      {{item.link === "/cn/solution/raas" ? "解决方案": null}}
                    </div>
                    <div class="header_drop_down_img">
                      <img src="../../assets/downarrow_cn.svg" class="header_language_image2">
                    </div>
                  </div>
                  <div v-if="item.link === '/cn/solution/raas' && showSolutionFlag" class="header_subtext_box">
                    <div class="header_subtext_1" @click="changeRouter('/cn/solution/raas')">RaaS方案</div>
                    <div class="header_subtext_2" @click="changeRouter('/cn/solution/baas')">BaaS方案</div>
                  </div>
                </div>
              </span>
            </div>
          </div>
          <div class="header_ad_button">
            <A-Button v-if="EN" text='Get Started' @onclick="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)"></A-Button>
            <A-Button v-else text='开始使用' @onclick="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)"></A-Button>
          </div>
        </div>
        <div class="header_nav_footer"  v-if='EN'>
          <span v-for="item in footerList" :key="item.name" class="header_nav_footer_text" @click="changeRouter(item.link, item.query)">
            {{item.name}}
          </span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: ['name'],
  data () {
    return {
      pageList: [
        {name: 'Home', link: 'home'},
        {name: 'Get Store', link: 'getstore'},
        {name: 'Services', link: 'services'},
        {name: 'Products', link: 'products', tab: true},
        {name: 'Blog', link: 'blog'},
        { name: 'Help Center', link: '/help' },
      ],
      pageList2: [
        {name: '首页', link: '/cn/home' },
        {name: '功能优势', link: '/cn/products'},
        {name: '解决方案', link: '/cn/solution/raas', tab: true},
        // {name: '成功案例', link: '/cn/success'},
        {name: '简介', link: '/cn/about-us'},
        {name: '资讯', link: '/cn/blog'},
      ],
      nameList: ['/home', '/services', '/products', '/blog', '/support','/online'],
      footerList: [
        {name: 'About Us', link: 'about'},
        {name: 'Privacy Policy', link: 'detail', query: 3},
        {name: 'Merchant Terms of Service', link: 'detail', query: 2},
        {name: 'Help Center', link: 'help'},
        {name: 'Top Stores', link: 'online'},
      ],
      nameList2: ['/products','/blog'],
      nameList3: ['/cn/home','/cn/products','/cn/support','/cn/blog'],
      isShowNav: false,
      height: 0,
      showProductFlag:false,
      showSolutionFlag: false,
      source: localStorage.getItem('ant_source') || '',
      EN:true,
      Language:false,
      Languagemobile:'English'
    }
  },
  methods: {
    changeRouter (link, type) {
      let query = {}
      if (type) {
        query = {p: type}
      }
      // 保持展开状态
      if (this.showProductFlag) {
        this.showTab('Products')
      }
      this.isShowNav = false
      this.$router.push({
        path: link,
        query
      }).catch(err => {
        // console.log('e',err)
      })
    },
    changeLanguage(index){
      this.isShowNav = false;
      this.Language = false;
      if(index=="EN"){
        this.EN=true
        this.Languagemobile='English'
        if(this.$route.path.slice(0,3)=='/cn'){
          if(this.nameList3.indexOf(this.$route.path)!=-1){
            this.$router.push({
               path: this.$route.path.slice(3)
            })
          }else{
            this.$router.push({
              path: '/home'
            })
          }
        }
      }else{
        this.EN=false
        this.Languagemobile='简体中文'
        if(this.$route.path.slice(0,3)!='/cn'){
          if(this.nameList2.indexOf(this.$route.path)!=-1){
            this.$router.push({
              path: '/cn'+this.$route.path
            })
          }else{
            this.$router.push({
              path: '/cn/home'
            })
          }
        }
      }
    },
    goLink (url) {
      window.open(url)
    },
    handleScrollx() {
      this.height = window.pageYOffset
    },
    showTab (name) {
      // console.log(name)
      if( name === "Products" ) {
        this.showProductFlag = !this.showProductFlag;
        if (this.showProductFlag) {
          document.querySelector(".header_drop_down_text.proTag").style.color="#fc5322"
          document.querySelector('.header_drop_down_img_button.proTag').style.transform = "rotate(-180deg)"
        } else {
          document.querySelector(".header_drop_down_text.proTag").style.color="black"
          document.querySelector('.header_drop_down_img_button.proTag').style.transform = "rotate(0deg)"
        }
      } else if (name === "Language"){
        this.Language=!this.Language
      } else if (name === "解决方案") {
        this.showSolutionFlag = !this.showSolutionFlag;
      }
    },
  },
  mounted(){
    window.addEventListener('scroll', this.handleScrollx, true)
  },
  created(){
    if(this.$route.path.slice(0,3)=='/cn'){
      this.EN=false
      this.Languagemobile='简体中文'
    }else{
      this.EN=true
      this.Languagemobile='English'
    }
  },
  watch: {
    '$route.path': function (newVal, oldVal) {
      if(newVal.slice(0,3)=='/cn'){
        this.EN=false
        this.Languagemobile='简体中文'
      }else{
        this.EN=true
        this.Languagemobile='English'
      }
    }
  }
}
</script>

<style scoped>
  .header{
    width: 100%;
    /* height: 0.96rem; */
    position: fixed;
    top: 0;
    z-index: 999;
    /* box-shadow: 0px 8px 8px 0px rgba(31,41,64,0.1); */
  }
  .header_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.24rem 0.46rem 0.18rem;
    background: #fff;
  }
  .header_box_cn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.42rem 0.48rem;
    background: #010119;
  }
  .header_page_language{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: .285rem;
  }
  .header_page_language span{
    font-family: SourceHanSansCN-Medium;
    font-size: .33rem;
    color: #222536;
    letter-spacing: 0;
    font-weight: 500;
    margin-left: .16rem;
  }
  .header_nav_box_cn .header_page_language span{
    font-size: .38rem;
    color: #FFFFFF;
  }
  .header_page_language div{
    display: flex;
    align-items: center;
  }
  .header_language_image1{
    width: .28rem;
    height: .28rem;
  }
  .header_language_image2{
    width: .22rem;
    height: .22rem;
  }
  .header_nav_box_cn .header_language_image1{
    width: .39rem;
    height: .39rem;
  }
  .header_nav_box_cn .header_language_image2{
    width: .39rem;
    height: .21rem;
  }
  .header_box_right{
    display: flex;
    align-items: center;
  }
  .header_box .header_logo{
    height: .72rem;
    width: 2.62rem;
    cursor: pointer;
    zoom: 0.88;
  }
  .header_box_cn .header_logo {
    height: .76rem;
    width: 2.74rem;
    cursor: pointer;
  }
  .header_box .header_more{
    /* float: right; */
    width: .4rem;
    height: .4rem;
    /* margin: 0.11rem 0 ; */
  }
  .header_box_cn .header_more {
    width: .42rem;
    height: .42rem;
  }

  .header_sign{
    /* float: right; */
    margin: 0 .38rem;
    font-weight: 500;
    color: #222536;
    font-family: Helvetica;
    border-radius: 8px;
    border: 1px solid #FC5322;
    font-size: .31rem;
    font-family: Helvetica;
    font-weight: 500;
    color: #FC5322;
    line-height: .54rem;
    padding: 0 .15rem;
  }
  .header_nav{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto hidden;
    transform: translateX(100%);
  }
  .header_nav_show{
    transform: translateX(0);
  }
  .header_nav_show1{
    transition: all 0.7s;
  }
  .header_nav .header_nav_bg{
    opacity: 0;
  }
  .header_nav_show .header_nav_bg{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000000;
    opacity: 0.49;
    transition: all 0.7s;
  }
  .header_nav_box{
    position: absolute;
    top: 0;
    right: -5.45rem;
    bottom: 0;
    width: 5.45rem;
    /* margin-left: 1.75rem; */
    background: #fff;
    /* padding: 0 .46rem; */
    display: flex;
    flex-direction: column;
    transition: all 0.7s;
    overflow: auto;
    transform: translateX(100%);
  }
  .header_nav_box_cn {
    width: 100vw;
    background-image: radial-gradient(circle at 50% 57%, #060834 0%, #02021D 46%);
  }
  .header_nav_show .header_nav_box{
    transform: translateX(0);
  }

  .header_nav_top{
    padding: .28rem 0.46rem 1.15rem .46rem;
  }
  .header_nav_box_cn .header_nav_top {
    padding: .42rem 0.48rem;
  }

  .header_nav_top_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: right;
  }
  .header_nav_top_box .header_nav_logo {
    width: 2.74rem;
    height: .76rem;
  }
  .header_nav_top_box .header_nav_close {
    width: .4rem;
    height: .4rem;
  }
  .header_nav_top_box .header_nav_close2{
    width: .38rem;
    height: .38rem;
  }
  .header_page{
    margin: .78rem 0 2.13rem;
  }
  .header_text{
    font-size: .33rem;
    /* font-family: Helvetica; */
    font-family: Helvetica;
    font-weight: 500;
    color: #222536;
    line-height: .54rem;
    display: block;
    position: relative;
    margin-top: .27rem;
  }
  .header_nav_box_cn .header_text{
    font-size: .38rem;
    color: #FFFFFF;
  }
  .header_text + .header_text{
    margin-top: .54rem;
  }
  .header_text::after{
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: #F6F7FA;
    top: -.27rem;
    left: 0;
  }
  .header_nav_box_cn .header_text::after{
    background: #616787;
  }
  .header_text:last-child::before{
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: #F6F7FA;
    top: .77rem;
    left: 0;
  }
  .header_nav_box_cn .header_text:last-child::before{
    background: #616787;
  }
  .header_subtext_box{
    font-size: .33rem;
    font-weight: 500;
    color: rgba(34,47,54,.6);
  }
  .header_nav_box_cn .header_subtext_box {
    font-size: .32rem;
    color: #FFFFFF;
  }
  .header_subtext_1 {
    padding: 0.14rem 0 0.28rem;
    border-bottom: 1px solid #F6F7FA;
    line-height: 1;
  }
  .header_nav_box_cn .header_subtext_1 {
    border-bottom: 1px solid #616787;
    padding: 0.12rem 0 0.35rem;
    color: #9FA5C3;
  }
  .header_subtext_2{
    padding: .28rem 0;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    line-height: 1;
  }
  .header_nav_box_cn .header_subtext_2 {
    padding: .35rem 0;
    color: #9FA5C3;
  }
  .drop_down_tab{
    margin-top: .3rem;
    position: relative;
  }
  .drop_down_tab:after{
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: #F6F7FA;
    top: -0.01rem;
    left: 0;
  }
  .header_nav_box_cn .drop_down_tab:after{
    background: #616787;
  }
  .last_box {
    border-bottom: none;
  }
  .header_drop_down {
    height: 1.08rem;
    font-size: 0.4rem;
    /* font-family: Helvetica; */
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222536;
    line-height: 1.08rem;
    transition: all 0.3s;
  }
  .header_drop_down_top {
    display: flex;
    height: 1.08rem;
  }
  .header_drop_down_text {
    margin-right: 0.2rem;
    font-size: .33rem;
    font-weight: 500;
  }
  .header_nav_box_cn .header_drop_down_text {
    color: #FFFFFF;
    font-size: .38rem;
  }
  .header_drop_down_img {
    flex: 1;
  }
  .header_nav_box_cn .header_drop_down_img {
    text-align: right;
  }
  .header_drop_down_img > img {
    transition: all 0.5s;
  }
  .header_drop_down img {
    width: 0.24rem;
  }

  .ad_button{
    width: 100%;
    text-align: center;
  }
  .header_nav_box_cn .ad_button {
    font-size: .32rem;
    line-height: 1;
    letter-spacing: 2.91px;
  }
  .header_nav_footer{
    background: #F6F7FA;
    padding: 1.32rem .46rem .46rem;
    flex: 1;
  }
  .header_nav_footer_text{
    display: block;
    font-size: .31rem;
    font-family: Helvetica;
    color: #222536;
    line-height: .31rem;
  }
  .header_nav_footer_text + .header_nav_footer_text{
    margin-top: .46rem;
  }
  .header_nav_show .header_nav_box{
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/mobileHeader.vue